import React from 'react'

import {
  FormGroup, FormControl, ControlLabel
} from 'react-bootstrap'

import { getText } from '../../lib/text'


type Props = {
  onChange: (string, string) => void, 
  item: {
    recommendedTransportation: string, 
    recommendedTransportationOther: ?string
  },
  title: ?string
}

const CommutingForm = ({ item, onChange, title, style }: Props) => (
  <div style={style}>

    {/* Medio de transporte recomendado */}

    <FormGroup>
      <ControlLabel>{title || getText("Cómo llegar:")}</ControlLabel>
      <FormControl
        componentClass="select"
        placeholder="select"
        value={item.recommendedTransportation || "NULL"}
        onChange={evt => {
          const v = evt.target.value == "NULL" ? null : evt.target.value
          onChange("recommendedTransportation", v)
        }}
      >
        {
          [
            { value: "NULL"       , text: getText("RT_NULL")       }, 
            { value: "PUBLIC_TPT" , text: getText("RT_PUBLIC_TPT") }, 
            { value: "WALKING"    , text: getText("RT_WALKING")    }, 
            { value: "DRIVE"      , text: getText("RT_DRIVE")      }, 
            { value: "CABIFY"     , text: getText("RT_CABIFY")     }, 
            { value: "GUIDE"      , text: getText("RT_GUIDE")      }, 
            { value: "TAXI"       , text: getText("RT_TAXI")       }, 
            { value: "OTHER"      , text: getText("RT_OTHER")      }, 
          ].map(({ value, text }) => (
            <option key={value} value={value}>{text}</option>
          ))
        }
      </FormControl>
    </FormGroup>

    {
      item.recommendedTransportation == "OTHER" && (
        <FormGroup>
          <ControlLabel>{getText("Recomendación (🇨🇳 ):")}</ControlLabel>
          <FormControl
            value={item.recommendedTransportationOther || ""}
            onChange={evt => onChange("recommendedTransportationOther", evt.target.value)}
          />
        </FormGroup>
      )
    }

  </div>
)

export default CommutingForm
